import useRead from '../../useRead';

const useGetFaq = (faqId) => {
  const {
    data,
    paramsObject,
    setGetListParams,
  } = useRead({
    url: "faqs/view",
    initialData: faqId ? { faq_id: faqId } : {},
    method: "GET",
    enabled: !!faqId,
  });

  return {
    data,
    paramsObject,
    setGetListParams,
  };
};

export default useGetFaq;
